import { render, staticRenderFns } from "./ResourceStatsNavigation.vue?vue&type=template&id=6f6fa380"
import script from "./ResourceStatsNavigation.vue?vue&type=script&lang=js"
export * from "./ResourceStatsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports